import React from 'react'
import { Col, Row } from 'react-bootstrap'

const PlanPaymentStepper = ({
  currentStep = 1,
  isComplete = false,
  selected = null,
  isQuestPayment = false,
  stepCount,
  isCoachingPlanPayment = false,
}) => {
  // // If stepCount is provided, use it to control the number of steps
  // if (stepCount === 2) {
  //   return (
  //     <div className='plan-payment-stepper'>
  //       <Row className='d-flex justify-content-center'>
  //         <Col xl={7} lg={8} md={6} sm={6} xs={6}>
  //           <div className='stepper-container mb-2'>
  //             <div
  //               className={`step-circle step-1 ${
  //                 currentStep === 1 && !isComplete ? 'inactive' : ''
  //               }`}>
  //               1
  //             </div>
  //             <div
  //               className={`step-line ${
  //                 currentStep === 1 && !isComplete ? '' : 'active'
  //               }`}></div>
  //             <div
  //               className={`step-circle step-2 ${
  //                 currentStep === 2 ? 'active' : ''
  //               } ${isComplete ? 'completed' : ''}`}>
  //               2
  //             </div>
  //           </div>
  //         </Col>
  //         <Col
  //           xl={12}
  //           lg={12}
  //           md={12}
  //           sm={12}
  //           xs={12}
  //           className='d-flex justify-content-center'>
  //           <div className='step-labels s9a justify-content-between'>
  //             <div className='step-label step-1 text-nowrap'>
  //               Payment Method
  //             </div>
  //             <div
  //               className={`step-label step-2 text-nowrap ${
  //                 currentStep === 2 || isComplete ? 'active' : ''
  //               }`}>
  //               Pay
  //             </div>
  //           </div>
  //         </Col>
  //       </Row>
  //     </div>
  //   )
  // }
  // Default: 3 steps (or fallback to original logic)
  return (
    <>
      {isCoachingPlanPayment ? (
        <>
          <div className='plan-payment-stepper'>
            <Row className='d-flex justify-content-center'>
              <Col xl={7} lg={8} md={6} sm={6} xs={6}>
                <div className='stepper-container mb-2'>
                  <div
                    className={`step-circle step-1 ${
                      currentStep === 1 && !isComplete ? 'inactive' : ''
                    }`}>
                    1
                  </div>
                  <div
                    className={`step-line ${
                      currentStep === 1 && !isComplete ? '' : 'active'
                    }`}></div>
                  <div
                    className={`step-circle step-2 ${
                      currentStep === 2 ? 'active' : ''
                    } ${isComplete && !isQuestPayment ? 'completed' : ''}`}>
                    2
                  </div>
                </div>
              </Col>
              <Col
                xl={12}
                lg={12}
                md={12}
                sm={12}
                xs={12}
                className='d-flex justify-content-center'>
                <div className='step-labels s9a justify-content-between'>
                  <div className='step-label step-1 text-nowrap'>
                    Payment Method{' '}
                  </div>
                  <div
                    className={`step-label step-2 text-nowrap ${
                      currentStep === 2 || isComplete ? 'active' : ''
                    }`}>
                    Billing Information
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </>
      ) : stepCount === 2 ? (
        <>
          <div className='plan-payment-stepper'>
            <Row className='d-flex justify-content-center'>
              <Col xl={7} lg={8} md={6} sm={6} xs={6}>
                <div className='stepper-container mb-2'>
                  <div
                    className={`step-circle step-1 ${
                      currentStep === 1 && !isComplete ? 'inactive' : ''
                    }`}>
                    1
                  </div>
                  <div
                    className={`step-line ${
                      currentStep === 1 && !isComplete ? '' : 'active'
                    }`}></div>
                  <div
                    className={`step-circle step-2 ${
                      currentStep === 2 ? 'active' : ''
                    } ${isComplete && !isQuestPayment ? 'completed' : ''}`}>
                    2
                  </div>
                </div>
              </Col>
              <Col
                xl={12}
                lg={12}
                md={12}
                sm={12}
                xs={12}
                className='d-flex justify-content-center'>
                <div className='step-labels s9a justify-content-between'>
                  <div className='step-label step-1 text-nowrap'>
                    Payment Method{' '}
                  </div>
                  <div
                    className={`step-label step-2 text-nowrap ${
                      currentStep === 2 || isComplete ? 'active' : ''
                    }`}>
                    {selected !== 'wire_transfer'
                      ? 'Pay Information'
                      : 'Billing Information'}
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </>
      ) : (
        stepCount !== 2 && (
          <>
            <div className='plan-payment-stepper'>
              <Row className='d-flex justify-content-center'>
                <Col xl={12} lg={12} md={12} sm={12} xs={12} className='ms-2'>
                  <div className='stepper-container mb-2'>
                    {/* Step 1 */}
                    <div
                      className={`step-circle step-1 ${
                        currentStep === 1
                          ? 'inactive'
                          : currentStep > 1
                          ? 'completed'
                          : 'active'
                      }`}>
                      1
                    </div>
                    {/* Line 1-2 */}
                    <div
                      className={`step-line ${
                        currentStep > 1 ? 'active' : ''
                      }`}></div>
                    {/* Step 2 */}
                    <div
                      className={`step-circle step-2 ${
                        currentStep === 2
                          ? 'active'
                          : currentStep > 2
                          ? 'completed'
                          : 'inactive'
                      }`}>
                      2
                    </div>
                    {/* Line 2-3 */}
                    <div
                      className={`step-line ${
                        currentStep > 2 ? 'active' : ''
                      }`}></div>
                    {/* Step 3 */}
                    <div
                      className={`step-circle step-2 ${
                        currentStep === 3
                          ? 'active'
                          : currentStep > 3
                          ? 'completed'
                          : 'inactive'
                      }`}>
                      3
                    </div>
                  </div>
                </Col>
                <Col
                  xl={12}
                  lg={12}
                  md={12}
                  sm={12}
                  xs={12}
                  className='px-0 step-title-info'>
                  <div className='step-labels s9a d-flex justify-content-between mb-0'>
                    <div
                      className={`step-label step-1 pe-0 card-info-label ${
                        currentStep === 1
                          ? 'active'
                          : currentStep > 1
                          ? 'completed'
                          : ''
                      }`}>
                      <span className='text-wrap'>Payment Method</span>
                    </div>
                    <div
                      className={`step-label step-2 billing-info-label ${
                        currentStep === 2
                          ? 'active'
                          : currentStep > 2
                          ? 'completed'
                          : ''
                      }`}>
                      <span className='text-wrap'>Billing Information</span>
                    </div>
                    <div
                      className={`step-label step-2 ${
                        currentStep === 3
                          ? 'active'
                          : currentStep > 3
                          ? 'completed'
                          : ''
                      }`}>
                      <span>Pay</span>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </>
        )
      )}
    </>
  )
}

export default PlanPaymentStepper
